// The storefront address rules live on WgptSite, and the availability endpoint
// reports which one a candidate breaks. Both places a dealer can pick an address
// — onboarding and the showroom settings page — turn that reason into the same
// sentence here, so neither has to keep its own copy of the rules.
const MESSAGE_KEYS = {
  taken: 'WGPT_CAR_SHOWROOM.SLUG_TAKEN',
  reserved: 'WGPT_CAR_SHOWROOM.SLUG_RESERVED',
  format: 'WGPT_CAR_SHOWROOM.SLUG_FORMAT_ERROR',
  blank: 'WGPT_CAR_SHOWROOM.SLUG_REQUIRED',
};

export const slugErrorMessage = (t, check) => {
  if (!check || check.available) return '';

  const key = MESSAGE_KEYS[check.reason];
  if (key) return t(key);

  // too_short / too_long — the endpoint sends the bounds so the message can
  // quote the real ones.
  return t('WGPT_CAR_SHOWROOM.SLUG_LENGTH_ERROR', {
    min: check.min_length,
    max: check.max_length,
  });
};
